// src/pages/Careers/Careers.jsx
import React, { useState, useEffect } from "react";
import CareersHero from "./components/CareersHero";
import BuildingSection from "./components/BuildingSection";
import JobDetailsModal from "./components/JobDetailsModal";
import AvailableRoles from "./components/AvailableRoles";
import CareerJourney from "./components/CareerJourney";
import ResumeCTA from "./components/ResumeCTA";
import CareersFinalCTA from "./components/CareersFinalCTA";

const Careers = () => {
  const [selectedJob, setSelectedJob] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleOpenResumeModal = () => {
    setSelectedJob(null);
    setIsModalOpen(true);
  };

  const handleOpenRoleModal = (roleTitle, domain) => {
    setSelectedJob({
      title: roleTitle,
      category: `${domain} Role`,
      type: "Full-Time",
    });
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedJob(null);
  };

  return (
    <div className="min-h-screen bg-white text-black font-sans selection:bg-black selection:text-white">
      {/* Hero Section */}
      <CareersHero
        onScrollToJobs={handleOpenResumeModal}
        onOpenResumeModal={handleOpenResumeModal}
      />

      {/* What We're Building */}
      <BuildingSection />

      {/* Available Roles Section */}
      <AvailableRoles onOpenRoleModal={handleOpenRoleModal} />

      {/* Career Journey */}
      <CareerJourney />

      {/* Spontaneous Resume CTA */}
      <ResumeCTA onOpenResumeModal={handleOpenResumeModal} />

      {/* Final Call to Action */}
      <CareersFinalCTA onScrollToJobs={handleOpenResumeModal} />

      {/* Application Modal */}
      <JobDetailsModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        selectedJob={selectedJob}
      />
    </div>
  );
};

export default Careers;
